import createAuth0Client from '@auth0/auth0-spa-js';
import { eAccessControlUserType } from 'ui-toolkit/enums/eAccessControlUserType';
import { IAuthenticationConfig } from '../types/AuthenticationConfig';

export const createAuth0ClientForSpruce = async (config: IAuthenticationConfig, userType: eAccessControlUserType) =>
  createAuth0Client({
    domain: config.tenant,
    client_id: config.client_id,
    audience: config.audience,
    redirect_uri: `${window.location.origin}/spa/logged_in`,
    connection: `${userType}-connection`,
    useRefreshTokens: true,
  });
